const endpoints = {
	auth: '/api/auth',
	doctor_specialties: '/api/doctor_specialties',
	doctors: '/api/doctors',
	general_parameters: '/api/general_parameters',
	login: '/api/v1/login',
	register: '/api/v1/register',
	medical_appointments: '/api/medical_appointments',
	availableTimes: '/api/v1/show-available-times',
	medical_records: '/api/medical_records',
	patients: '/api/patients',
	schedules: '/api/schedules',
	specialties: '/api/specialties',
	users: '/api/users',
	short_urls: '/api/short_url',

	getFlows: '/api/v1/flows',
	getUserType: '/api/v1/user-types/',
	createAppointment: '/api/v1/reservs',

	whatsapp: '/api/whatsapp',
	// Click2Call
	userData: '/api/userData',
	user: '/api/app/user/details',
	videollamada: '/api/calls/videoCall',
	videoEmail: '/api/calls/videoMail',
	speciality: '/api/company/specialities',
	callEvent: '/api/events',
	postFormContact: '/api/attention/contact',
	paisesActivos: '/api/auth/getPaisesActivos',
	regionesActivas: '/api/auth/getRegionesActivas',
	comunasActivas: '/api/auth/getComunasActivas',
	UpdateInfoVideoCall: '/api/calls/videoCall',


//payment
	getPaymentValue: '/api/app/planes/getToPayData',
	startPaymentPlan: '/api/app/pagos/createPurchaseOrder', // /app/pagos/createPurchaseOrder?product_id=1&qty=1
	getOrderStatusByToken: '/api/auth/getOrderStatusByToken',

//Registro
	getToken: 'api/token',

//SERVICIOS
	getServices: '/api/company/serviceStatus',

	fileUpload: 'api/calls/videoCall/{videoCallID}/publicAttachment',
	getFilePublicUrl: 'api/attachments/',

//     userData: '/api/userData',
//     user: '/api/app/user/details',
//     videollamada: '/api/calls/videoCall',
//     videoEmail: '/api/calls/videoMail',
//     speciality: '/api/company/specialities',
//     callEvent: '/api/events',
//     postFormContact: '/api/attention/contact',
//     paisesActivos: '/api/auth/getPaisesActivos',
//     regionesActivas: '/api/auth/getRegionesActivas',
//     comunasActivas: '/api/auth/getComunasActivas',
//
// //payment
//     getPaymentValue: '/api/app/planes/getToPayData',
//     startPaymentPlan: '/api/app/pagos/createPurchaseOrder', // /app/pagos/createPurchaseOrder?product_id=1&qty=1
//     getOrderStatusByToken: '/api/auth/getOrderStatusByToken',
//
// //Registro
//
//     getToken: 'api/token',
//
// //SERVICIOS
//     getServices: '/api/company/serviceStatus',
//
//     fileUpload: 'api/calls/videoCall/{videoCallID}/publicAttachment',
//     getFilePublicUrl: 'api/attachments/'
joinUserVideoCall: 'api/v1/join-user-videocall/',
reservationClient: 'api/v1/reservations-client',
confirmCancelAppointment: 'api/v1/confirm-reservation',
forgotPassword: '/v1/recover-password',
resetPass: '/v1/reset-password',
getReservationById: 'api/v1/reservs/',
createQuotaAppointment: 'api/v1/reservations-ordered/',
getQuota: 'api/v1/reservations-ordered-quota/',
getStatus: 'api/v1/status-pay/',
getFestivos: 'api/v1/festivos/',
}

export {endpoints}
